import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arbitration-calendar',
  templateUrl: './arbitration-calendar.component.html',
  styleUrls: ['./arbitration-calendar.component.scss']
})
export class ArbitrationCalendarComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
